import React, { useEffect, useRef, type JSX } from 'react'
import { SearchIcon } from '@ttab/elephant-ui/icons'
import { cn } from '@ttab/elephant-ui/utils'
import { useTranslation } from 'react-i18next'

interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
  type?: string
}

export const SearchInput = ({ className, type = 'text', ...props }: SearchInputProps): JSX.Element => {
  const inputRef = useRef<HTMLInputElement>(null)
  const { t } = useTranslation('common')

  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      inputRef.current?.focus()
    })

    return () => cancelAnimationFrame(frame)
  }, [])

  return (
    <div className='flex gap-1'>
      {/*
        A form without a submit button only submits on Enter while exactly one
        field blocks implicit submission, so a second one (Base UI's Select
        renders a hidden text input) silently stops Enter from searching.
      */}
      <button
        type='submit'
        aria-label={t('actions.search')}
        className='pl-1 flex items-center rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
      >
        <SearchIcon strokeWidth='1.75' size='18' />
      </button>
      <input
        type={type}
        ref={inputRef}
        className={cn(`flex h-10
          w-full
          border
          border-input
          rounded
          border-solid
          bg-background
          py-0
          ring-offset-background
          placeholder: pl-2
          placeholder:text-muted-foreground
          focus-visible:outline-none focus-visible:0
          disabled:cursor-not-allowed
          disabled:opacity-50`, className)}
        {...props}
      />

    </div>
  )
}
